import React from "react";
import { useTheme } from "../../../Hooks";
import { FmBasicModal } from "../..";
import { FmButton } from "../../FmButton";
import { ApiError } from "../../../Models";
import { useTranslation } from "react-i18next";
import useStyles from "./FmApiResponseErrorModal.style";
import { TextsUtils } from "../../../Utils";

interface FmApiResponseErrorModalProps {
    isOpen: boolean;
    onClose: () => void;
    data: ApiError;
}

const FmApiResponseErrorModal = ({ isOpen, onClose, data }: FmApiResponseErrorModalProps) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const classes = useStyles();

    const renderModal = () => {
        return (
            <FmBasicModal img={theme.images.errorApiModal} onClose={onClose} isOpen={isOpen} contentStyle={classes.content}>
                <div className={classes.container}>
                    <div className={classes.upperBody}>
                        <div className={classes.title}>{t("general.errorTitle")}</div>
                        <div className={classes.body}>
                            <div className={classes.bodyText}>
                                {t("general.service")} {data.serviceName ? data.serviceName : ""}
                            </div>
                            <div className={classes.bodyText}>
                                {t("general.statusCode")} {data.statusCode ? data.statusCode : 0}
                            </div>
                            <div className={classes.bodyText}>
                                {t("general.message")} {TextsUtils.getErrorMessage(t, data.errorMessage || "")}
                            </div>
                        </div>
                    </div>

                    <div className={classes.bottomBody}>
                        <FmButton fullWidth={"regular"} onClick={onClose}>
                            {t("general.tryAgain")}
                        </FmButton>
                    </div>
                </div>
            </FmBasicModal>
        );
    };
    return <div>{renderModal()}</div>;
};

export default FmApiResponseErrorModal;
